// extracted by mini-css-extract-plugin
module.exports = {"frame":"Frame_frame__2fwaN","number":"Frame_number__3m4mI","intensity":"Frame_intensity__1mDnz"};